import {Pipe, PipeTransform} from '@angular/core';
import {MacronutrientEnum} from '../../class/macronutrient-distribution-strategy/enums/macronutrient.enum';
import {MacronutrientDistribution} from '../../class/macronutrient-distribution-strategy/macronutrient-distribution';

@Pipe({
  name: 'calSmaeGrams'
})
export class CalSmaeGramsPipe implements PipeTransform {

  /*
  * Para sacar los gramos de cada macro solo se divide
  * el resultado de las calorías entre 4
  * (para HC y proteínas) o entre 9 para Grasas.
  * */

  transform(grams: number, macronutrientDistribution: MacronutrientDistribution, macro: MacronutrientEnum): string | null {
  
    const percentage = macronutrientDistribution[macro].defaultValue;
    
    if (macro === MacronutrientEnum.CARBOHYDRATES || macro === MacronutrientEnum.PROTEIN) {
      return (  (grams * (percentage / 100))  / 4).toFixed(2);
    } else if (macro === MacronutrientEnum.LIPIDS) {
      return ((grams * (percentage / 100)) / 9).toFixed(2);
    } else {
      return null;
    }
  }

}
